import DeveloperError from './DeveloperError';
class InvalidDeveloperId extends DeveloperError {
    developerId;
    constructor(developerId, options) {
        super('INVALID_DEVELOPER_ID', options);
        this.developerId = developerId;
    }
}
export default InvalidDeveloperId;
